module.exports = __webpack_public_path__ + "img/zz3.e3dd2064.jpg";